import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Grid from "@mui/material/Grid";

import PieCard from "../Components/Cards/Pie";
import BarCharts from "../Components/Cards/Bar_Charts";
import UsersCard from "../Components/Cards/Useres_Card";

import HomeIcon from "./../Assets/Icons/home.svg";
import UsersIcon from "./../Assets/Icons/Users.svg"

import { fetchStatistics } from "../Redux/statisticsSlice";

const Statistiken= () => {
  const dispatch = useDispatch();
  const [timeRange, setTimeRange] = useState("this week");
  const {
    reservationsNumber,
    usersNumber,
    popularPackages,
    profit,
    dailyBookings,
  } = useSelector((state) => state.statistics);

  const getDateFromTimeRange = (range) => {
    const now = new Date();
    const forDate = new Date(now);
    
    forDate.setHours(0, 0, 0, 0);

    if (range === "this day") {
      return forDate.toISOString();
    } else if (range === "this week") {
      forDate.setDate(now.getDate() - 7);
      return forDate.toISOString();
    } else if (range === "this month") {
      forDate.setMonth(now.getMonth() - 1);
      return forDate.toISOString();
    }
  };

  useEffect(() => {
    const forUsers = getDateFromTimeRange(timeRange);
    const forReservation = getDateFromTimeRange(timeRange);

    dispatch(
      fetchStatistics({
        forUsers,
        forReservation,
      })
    );
  }, [timeRange]);

  const pieData =
    popularPackages?.map((item) => ({
      label: item.name,
      value: item.count,
    })) || [];

  const barChartData = {
    profit: profit?.[0]?.total || 0,
    dailyBookings: dailyBookings || [],
  };

  const cardData = [
    {
      icon: HomeIcon,
      title: "Gesamtbuchungen",
      count: `${reservationsNumber || 0} Gesamtbuchungen`,
    },
    {
      icon: UsersIcon, 
      title: "Neue Kunden",
      count: `${usersNumber || 0} Kunden`,
    },
  ];

  return (
    <Grid container spacing={2}>
      {cardData.map((item, index) => (
        <Grid item size={{ xs: 12, md: 6, lg: 5 }} key={index}>
          <UsersCard {...item} timeRange={timeRange} setTimeRange={setTimeRange} />
        </Grid>
      ))}
      <Grid item size={{ xs: 12, md: 6, lg: 4.5 }}>
        <PieCard data={pieData} title={`Beliebte Pakete (${timeRange})`} />
      </Grid>
      <Grid item size={{ xs: 12, md: 12, lg: 7.5 }}>
        <BarCharts
          profit={barChartData.profit}
          dailyBookings={barChartData.dailyBookings}
          title="Statistiken"
        />
      </Grid>
    </Grid>
  );
};

export default Statistiken;
